module.exports = "<span title=\"{{description|e('html_attr')}}\">{{description|e}}</span>\n";
